import { Filter } from '~/mappers/itemListing/models';
import { filterNameFormat } from '~/utils/filterNameFormat';

export const getFilterValuesFromQueryString = (
  filters: Filter[],
  activeFilterElements: string[]
) =>
  filters
    .flatMap((filter) =>
      filter.options.map(({ categoryRef }) => ({
        group: filter.label,
        value: categoryRef,
      }))
    )
    .filter(
      ({ value: { uid, title }, group }) =>
        activeFilterElements?.includes(uid) ||
        activeFilterElements?.includes(filterNameFormat(group, title))
    );
